/**
 * Returns the result of normalizing an email address. For this use case, Google Ads
 * requires removal of any '.' characters preceding {@code gmail.com} or {@code googlemail.com}.
 *
 * @param email the email address to normalize and hash.
 */

export function normalizeEmailForGoogleAds(email) {
  const lowerCaseEmail = email.toLowerCase();
  const emailParts = lowerCaseEmail.split('@');
  const emailDomain = emailParts[1];
  const isGmailRegex = /^(gmail|googlemail)\.com$/;
  const isGmail = emailDomain.match(isGmailRegex);
  if (emailParts.length > 1 && isGmail) {
    // Removes any '.' characters from the portion of the email address before the domain if the
    // domain is gmail.com or googlemail.com.
    emailParts[0] = emailParts[0].replaceAll('.', '');
  }
  return emailParts.join('@').trim();
}
//# sourceMappingURL=google-ads-helper.js.map